import "./inventario.css";
import logo from "../../assets/logos/TRANSKYRIOS-_IconColor.avif";
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import Permiso from '../../components/wrappers/permiso';
import InventarioTable from "../../components/table/inventory-table";
import { obtenerProductos } from "../../services/inventarioService";
import { Toast } from 'primereact/toast';
import TableLayout from "../../layouts/layout-tabla";

export default function InventarioTK() {
    const navigate = useNavigate();
  const [data, setData] = useState([]);
  const toast = useRef(null);

  const fetchData = async () => {
    try {
      const productos = await obtenerProductos();
      setData(productos.productos || []);
      
    } catch (error) {
      toast.current.show({ 
        severity: 'error', 
        summary: 'Error', 
        detail: 'No se pudieron cargar los productos', 
        life: 3000 
      });
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <TableLayout titulo="Inventario" logo={logo} onVolver={() => navigate('/app')}>
      <Toast ref={toast} position="center"/>
      <section className="inv-content">
        <Permiso modulo="Inventario" permiso="INV_VER_INVENTARIO">
          <InventarioTable data={data} onActualizar={fetchData}/>
        </Permiso>
      </section>
    </TableLayout>
  );
}